module.exports = __webpack_public_path__ + "static/media/sn_yt.f80d6ac3.svg";